import { render, staticRenderFns } from "./OrganismEditionSectionContent.vue?vue&type=template&id=204bae3b"
import script from "./OrganismEditionSectionContent.vue?vue&type=script&lang=js"
export * from "./OrganismEditionSectionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports